// Default export
export default function StarRating({ value = 0, outOf = 5, size = 16 }) {
  const stars = [];
  for (let i = 1; i <= outOf; i++) {
    const filled = i <= value;
    stars.push(
      <span
        key={i}
        style={{
          fontSize: size,
          lineHeight: 1,
          color: filled ? "#facc15" : "#d1d5db", // yellow-400 vs gray-300
          marginRight: 2,
        }}
      >
        ★
      </span>
    );
  }

  return <div style={{ display: "inline-flex" }}>{stars}</div>;
}
